import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const DrawerFooterSx = {
	stickyFooter: {
		position: 'sticky',
		bottom: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
		p: '10px',
		bgcolor: 'rgba(255, 255, 255, 0.8)',
		backdropFilter: 'blur(10px)',
		WebkitBackdropFilter: 'blur(10px)',
		boxShadow: '0px -2px 10px 0px rgba(0, 0, 0, 0.1)',
	},
	button: {
		height: '40px',
		borderColor: 'success.main',
		border: '2px solid',
		'&.Mui-disabled': {
			backgroundColor: 'grey.50',
			color: 'grey.200',
			borderColor: 'grey.200',
		},
	},
};

export const DrawerPurchaseSx = {
	promotionField: {
		display: 'flex',
		gap: '10px',
		bgcolor: 'grey.50',
		borderRadius: '3px',
		p: '10px',
		alignItems: 'center',
	},
	group: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
		border: ' 1px solid',
		borderColor: 'grey.100',
		p: '10px',
		borderRadius: '2px',
	},
	groupSelected: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
		border: ' 1px solid',
		borderColor: 'grey.500',
		p: '10px',
		borderRadius: '2px',
	},
	productDetails: {
		display: 'flex',
		flexDirection: 'column',
		gap: '15px',
		alignItems: 'left',
	},
	parentProductChip: {
		bgcolor: 'grey.500',
		color: 'white',
		borderRadius: '3px',
		width: 'fit-content',
		fontSize: '12px',
		fontWeight: OpenSansFontWeights.semibold,
		p: '5px',
		'& .MuiChip-label': {
			p: 0,
		},
	},
	combinableGroup: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		border: '1px solid',
		borderColor: 'grey.100',
		borderRadius: '2px',
		p: '10px',
	},
	combinableGroupSelected: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		border: '1px solid',
		borderColor: 'grey.500',
		borderRadius: '2px',
		p: '10px',
	},
	disableOverlay: {
		position: 'absolute',
		inset: 0,
		bgcolor: 'rgba(230, 230, 230, 0.5)',
		cursor: 'not-allowed',
		zIndex: 1,
	},
	fields: {
		p: '0',
		color: 'grey.100',
		'&.Mui-checked': {
			color: 'grey.500',
		},
	},
	checkboxFields: {
		p: '0',
		'&.Mui-checked': {
			color: 'grey.500',
		},
		color: 'grey.100',
	},
	field: {
		width: '100%',
	},
};

export const DrawerRewardSx = {
	disableOverlay: {
		position: 'absolute',
		inset: 0,
		bgcolor: 'rgba(230, 230, 230, 0.5)',
		cursor: 'not-allowed',
		zIndex: 1,
	},
	container: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
		opacity: 0.5,
		transition: 'opacity 0.2s ease',
	},
	containerComplete: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
		opacity: 1,
		transition: 'opacity 0.2s ease',
	},
	fields: {
		p: '0',
		color: 'grey.100',
		'&.Mui-checked': {
			color: 'grey.500',
		},
	},
	checkboxFields: {
		p: '0',
		color: 'grey.100',
		'&.Mui-checked': {
			color: 'grey.500',
		},
	},
	group: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
		border: ' 1px solid',
		borderColor: 'grey.100',
		p: '10px',
		borderRadius: '2px',
	},
	groupSelected: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
		border: ' 1px solid',
		borderColor: 'grey.500',
		p: '10px',
		borderRadius: '2px',
	},
	combinableGroup: {
		position: 'relative',
		display: 'flex',
		border: ' 1px solid',
		borderColor: 'grey.100',
		p: '10px',
		borderRadius: '2px',
	},
	combinableGroupSelected: {
		position: 'relative',
		display: 'flex',
		border: ' 1px solid',
		borderColor: 'grey.500',
		p: '10px',
		borderRadius: '2px',
	},
	parentProductChip: {
		bgcolor: 'grey.500',
		color: 'white',
		borderRadius: '3px',
		width: 'fit-content',
		fontSize: '12px',
		fontWeight: OpenSansFontWeights.semibold,
		p: '5px',
		'& .MuiChip-label': {
			p: 0,
		},
	},
};

export const NumberBadgeSx = {
	bagdeContainer: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexShrink: 0,
		height: '20px',
		width: '20px',
		borderRadius: '50%',
		border: '1px solid',
		borderColor: 'primary.main',
		color: 'primary.main',
		fontWeight: OpenSansFontWeights.semibold,
		fontSize: '12px',
		lineHeight: '12px',
	},
};

export const ProductDetailsSx = {
	parentChip: {
		bgcolor: 'grey.500',
		color: 'white',
		borderRadius: '3px',
		width: 'fit-content',
		fontSize: '12px',
		fontWeight: OpenSansFontWeights.semibold,
		p: '5px',
		'& .MuiChip-label': {
			p: 0,
		},
	},
	image: {
		width: '90px',
		height: '90px',
	},
	imageContainer: {
		maxWidth: '90px',
		height: '90px',
		width: '100%',
		alignSelf: 'center',
	},
	container: {
		display: 'flex',
		gap: '10px',
		alignItems: 'center',
	},
	detailsContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
		width: '100%',
		height: '100%',
	},
	priceText: {
		textDecoration: 'line-through',
	},
	outOfStock: {
		opacity: 0.6,
	},
};

export const ProductBubbleSx = {
	badge: {
		'& .MuiBadge-badge': {
			backgroundColor: 'success.light',
			color: 'success.dark',
			fontWeight: OpenSansFontWeights.semibold,
		},
	},
	badgePurchase: {
		'& .MuiBadge-badge': {
			backgroundColor: 'grey.50',
			color: 'grey.200',
			fontWeight: OpenSansFontWeights.semibold,
		},
	},
	image: {
		height: '60px',
		width: '60px',
	},
};

export const PromotionBlockSx = {
	container: {
		display: 'flex',
		gap: '10px',
		alignItems: 'center',
	},
};

export const PromotionDrawerSx = {
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: '100vh',
		overflow: 'hidden',
	},
	contentContainer: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		overflowY: 'auto',
		p: '10px',
		gap: '15px',
	},
	drawerPaper: {
		'.MuiDrawer-paper': {
			width: { md: '100%', lg: 360 },
			maxHeight: { xs: '80vh', lg: '100%' },
			bottom: '60px',
		},
	},
	drawerPaperMobile: {
		'.MuiDrawer-paper': {
			width: { md: '100%', lg: 360 },
			maxHeight: { xs: '80vh', lg: '100%' },
		},
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		p: '15px 20px',
		textAlign: 'left',
	},
	title: {
		width: '100%',
	},
	closeButton: {
		color: 'grey.200',
		cursor: 'pointer',
		fontSize: '20px',
		':hover': {
			color: 'primary.main',
		},
	},
};

export const PromotionFooterSx = {
	button: {
		height: '40px',
		'&:hover': {
			backgroundColor: 'primary.main',
			color: 'white',
			borderColor: 'primary.main',
		},
		'& .MuiButton-startIcon': {
			marginRight: '5px',
			marginLeft: 0,
		},
	},
	successAlert: {
		bgcolor: 'success.light',
		color: 'success.dark',
		borderRadius: '3px',
		p: '5px',
		'& .MuiAlert-icon': {
			color: 'success.dark',
			p: '0',
			mr: '3px',
		},
		'& .MuiAlert-message': {
			p: '0',
			fontSize: '15px',
			alignSelf: 'center',
			lineHeight: '1.4',
		},
	},
	infoAlert: {
		bgcolor: 'grey.50',
		color: 'grey.300',
		p: '5px',
		'& .MuiAlert-icon': {
			color: 'grey.300',
			p: '0',
			mr: '3px',
		},
		'& .MuiAlert-message': {
			p: '0',
			fontSize: '15px',
			alignSelf: 'center',
			lineHeight: '1.4',
		},
	},
};

export const DrawerContentSx = {
	insufficientItemsAlert: {
		bgcolor: 'error.light',
		color: 'error.dark',
		borderRadius: '3px',
		p: '5px',
		'& .MuiAlert-icon': {
			color: 'error.dark',
			p: '0',
			mr: '3px',
			alignItems: 'center',
		},
		'& .MuiAlert-message': {
			p: '0',
			fontSize: '15px',
			alignSelf: 'center',
			lineHeight: '1.4',
		},
	},
};

export const PromotionTitleSx = {
	chip: {
		bgcolor: '#D7F8DC',
		color: 'success.dark',
		borderRadius: '4px',
		width: 'fit-content',
		fontSize: '12px',
		fontWeight: '600',
		p: '5px',
		'& .MuiChip-label': {
			p: 0,
			lineHeight: '1.4',
		},
	},
	titleText: {
		fontFamily: 'HelveticaNeue_THD, "Open Sans", "Helvetica Neue", Arial, sans-serif;',
		color: 'grey.500',
	},
};

export const PurchaseBlockSx = {
	fieldset: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		border: '1px solid',
		borderColor: 'divider',
		borderRadius: '3px',
		pt: 0,
		px: '10px',
		pb: '10px',
		width: { xs: '100%', md: 'unset' },
	},
	titleText: {
		fontFamily: 'HelveticaNeue_THD, "Open Sans", "Helvetica Neue", Arial, sans-serif;',
	},
};

export const RewardBlockSx = {
	fieldset: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		border: '1px solid',
		borderColor: 'success.main',
		borderRadius: '3px',
		pt: 0,
		px: '10px',
		pb: '10px',
		width: { xs: '100%', md: 'unset' },
	},
	badge: {
		'& .MuiBadge-badge': {
			minWidth: '18px',
			height: '18px',
			backgroundColor: 'success.light',
			color: 'success.dark',
			fontWeight: OpenSansFontWeights.semibold,
			p: '0',
		},
	},
	missingItemsBox: {
		width: '60px',
		height: '60px',
		p: '10px',
	},
};

export const PurchaseBuyItemSx = {
	container: {
		height: '60px',
		width: '60px',
		border: '1px dashed',
		borderColor: 'grey.100',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '5px',
		p: '5px',
	},
	badge: {
		'& .MuiBadge-badge': {
			backgroundColor: 'grey.50',
			color: 'grey.200',
			fontWeight: OpenSansFontWeights.semibold,
			minWidth: '18px',
			height: '18px',
			p: '0',
		},
	},
};

export const MultiPromosSx = {
	promoContainer: {
		display: 'flex',
		border: '1px solid',
		borderColor: 'grey.100',
		borderRadius: '2px',
		cursor: 'pointer',
		p: '10px',
		width: '100%',
	},
	image: {
		width: '60px',
		height: '60px',
	},
};
